import React from 'react'
import { PropTypes } from 'prop-types'
import styled from 'styled-components'

import Highlight from '../../Highlight'

const ContainerSection = styled.div`
  border-top: 1px solid #e1e7e6;
  padding-top: 20px;
  margin-top: 30px;
`
const Section = ({ sections, menuOption }) => {
  const section = sections.filter(({ slug }) => slug === menuOption)
  const { sectionPage: { childMarkdownRemark } } = section[0]
  return (
    <ContainerSection>
      <Highlight content={childMarkdownRemark.html} />
    </ContainerSection>
  )
}

Section.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape()),
  menuOption: PropTypes.string
}

Section.defaultProps = {
  setMenuOption: '',
  sections: []
}

export default Section
